import { isArray } from '@hc-frontend/utils'
import sessionData from 'core/sessionData'
import { IS_FIXED_BENEFIT_MEDICAL } from 'core/constants/environment'

let plansFromSession = []
let compareSessionKey = IS_FIXED_BENEFIT_MEDICAL ? 'FBM_COMPARE' : 'STM_COMPARE'
let maxPlansToCompare = 3

function addPlan(id: string) {
  if (plansFromSession.includes(id)) {
    return
  }

  plansFromSession.push(id)

  if (plansFromSession.length > maxPlansToCompare) {
    plansFromSession.shift()
  }

  sessionData.setData(compareSessionKey, plansFromSession)
}

function removeAllPlans() {
  plansFromSession = []
  sessionData.setData(compareSessionKey, plansFromSession)
}

function removePlan(id) {
  const position = plansFromSession.indexOf(id)
  plansFromSession.splice(position, 1)
  sessionData.setData(compareSessionKey, plansFromSession)
}

function getPlans(healthcareSession) {
  compareSessionKey = `${compareSessionKey}_${healthcareSession}`
  return sessionData.getData(compareSessionKey) || []
}

function init(healthcareSession, maxPlans) {
  plansFromSession = getPlans(healthcareSession)
  maxPlansToCompare = maxPlans

  return (isArray(plansFromSession) && plansFromSession) || []
}

export default {
  init,
  addPlan,
  removePlan,
  removeAllPlans,
  getPlans
}
